import $http from '@Config/axios';
import $store from '@Store';

const prefix = 'usuario';
const tipo = 'Usuário';
const artigo = 'o';

const getDataUri = targetUrl => new Promise(resolve => {
  const xhr = new XMLHttpRequest();
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  const proxyUrl = 'https://medyes-cors-anywhere.onrender.com/';
  xhr.open('GET', proxyUrl + targetUrl);
  xhr.responseType = 'blob';
  xhr.send();
});

export default {
  index() {
    return new Promise((resolve, reject) => {
      $http.get(prefix)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  show(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}`)
        .then(response => resolve({
          id: response.id,
          usuario: response.usuario,
          configuracoes: response.configuracoes
        }))
        .catch(response => reject(response));
    });
  },
  store(params) {
    return new Promise((resolve, reject) => {
      $http.post(prefix, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: `${tipo} criad${artigo} com sucesso!`
          });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  update(params) {
    return new Promise((resolve, reject) => {
      $http.put(prefix, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: `${tipo} atualizad${artigo} com sucesso!`
          });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  cadastro(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/cadastro`, params)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: 'Cadastro realido com sucesso! Por favor, faça o login.'
          });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  contextoToken(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/contexto-token`, params)
        .then(response => {
          if (response.contexto.instituicao.avatar)
            getDataUri(response.contexto.instituicao.avatar).then(base_64 => {
              $store.dispatch('AVATAR_BASE64', base_64);
            });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  loginUsuario(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/login-usuario`, params)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  login(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/login`, params)
        .then(async response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  showAsPaciente(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  atualizarSenha(senhas) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/atualizarSenha`, senhas)
        .then(response => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: 'Senha atualizada com sucesso'
          });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  search(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/search`, params)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  count() {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/count`)
        .then(response => {
          resolve(response.count);
        })
        .catch(response => reject(response));
    });
  },
  getContexto() {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/etc/contexto`)
        .then(async response => {
          if (response.instituicao.avatar)
            getDataUri(response.instituicao.avatar).then(base_64 => {
              $store.dispatch('AVATAR_BASE64', base_64);
            });
          resolve(response);
        })
        .catch(response => reject(response));
    });
  },
  storeConfiguracoes(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/configuracoes`, params)
        .then(contexto => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: 'Configurações salvas com sucesso'
          });
          resolve(contexto);
        })
        .catch(response => reject(response));
    });
  },
  storeConfiguracoesUsuario(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/configuracoesUsuario`, params)
        .then(contexto => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: 'Configurações salvas com sucesso'
          });
          resolve(contexto);
        })
        .catch(response => reject(response));
    });
  },
  updateConfiguracoesUsuario(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/updateConfiguracoesUsuario`, params)
        .then(contexto => {
          $store.dispatch('SHOW_SNACKBAR', {
            message: 'Configurações salvas com sucesso'
          });
          resolve(contexto);
        })
        .catch(response => reject(response));
    });
  },
  storeConfiguracoesNoMessage(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/configuracoes`, params)
        .then(contexto => {
          resolve(contexto);
        })
        .catch(response => reject(response));
    });
  },
  showNome(id) {
    return new Promise((resolve, reject) => {
      $http.get(`${prefix}/${id}/shownome`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
